import React from 'react';

import './inboundTemplate.scss';

const CustomParamChip = ({ text, onClick, disabled }) => {
  const handleClick = (e) => {
    // Prevent any default actions that might interfere with focus
    e.preventDefault();
    e.stopPropagation();

    if (!disabled && onClick) {
      onClick(e);
    }
  };

  return (
    <div
      className={`custom-param-chip ${disabled ? 'disabled' : ''}`}
      onClick={handleClick}
      tabIndex={-1} // Make it not focusable to avoid stealing focus
    >
      {text}
    </div>
  );
};

export default CustomParamChip;
